module.exports = __webpack_public_path__ + "img/area-huanan.141dd929.png";